import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { type RespondByChange } from '@modules/common/components/item-handover/handover-respond-by';
import { owningTenantContext } from '@modules/common/interceptors/spaces.interceptor';
import { type Observable } from 'rxjs';

export type ItemChangesPath =
  | '/api/tasking/tasks'
  | '/api/contacts/contacts'
  | '/api/files/files'
  | '/api/calendar/events'
  | '/api/mail/messages';

export interface ItemChange {
  readonly uid: string;
  readonly author: { readonly id: string; readonly name: string | null } | null;
  readonly at: string;
  readonly fields: readonly string[];
  readonly excerpt: string;
  /** Only on a respond-by change: the instants to word in the account zone. A row without them (an older server) shows `excerpt`. */
  readonly respondBy?: RespondByChange;
}
export interface ItemChangesPage {
  readonly items: readonly ItemChange[];
  readonly total: number;
}

/** Provided by the Activity view so it captures the form's workspace-scoped HTTP client. */
@Injectable()
export class ItemChangesClient {
  private readonly http = inject(HttpClient);

  public read(path: ItemChangesPath, itemId: string, tenantId: string, offset: number): Observable<ItemChangesPage> {
    return this.http.get<ItemChangesPage>(`${environment.baseUrl}${path}/${itemId}/changes`, {
      params: new HttpParams().set('offset', offset).set('limit', 20),
      context: owningTenantContext(tenantId),
    });
  }
}
